var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppState from '../../AppState';
import onePlatformSystemError from "./onePlatformSystemError";
/**
 * One Platform create quote.
 *
 * @param {OnePlatformSQ} serviceQualificationObject
 *   The service address object obtained via One Platform.
 * @param {ProductOfferingObject} productOffering
 *   The product offering object.
 * @param {string} token
 *   The GUID generated.
 * @returns {Promise<Quote>}
 *   An object containing the quote object.
 * @throws {Error}
 *   If there is an error with quote creation.
 */
const onePlatformQuoteCreate = (serviceQualificationObject, productOffering, token) => __awaiter(void 0, void 0, void 0, function* () {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { settings } = drupalJsObjects;
    const { onePlatformApiRoot, onePlatformApiClientId, onePlatformApiClientSecret, onePlatformApiQuote } = settings;
    const quoteEndpoint = onePlatformApiRoot + onePlatformApiQuote;
    const quotePayloadDataBuild = {
        'category': 'iPrimus',
        'product': {
            'id': productOffering[0].productOffering[0].id
        },
        'sqdetails': serviceQualificationObject
    };
    const quotePayloadData = JSON.stringify(quotePayloadDataBuild);
    try {
        const response = yield fetch(quoteEndpoint, {
            method: 'post',
            headers: {
                'client_id': onePlatformApiClientId,
                'client_secret': onePlatformApiClientSecret,
                'quoteIdToken': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: quotePayloadData
        });
        if (!response.ok) {
            onePlatformSystemError();
        }
        else {
            return yield response.json();
        }
    }
    catch (error) {
        console.error('onePlatformQuoteCreate error.');
    }
});
export default onePlatformQuoteCreate;
